<template>
    <div class="contact-title v-flex">
        <div
            v-if="length > 0"
            class="contact-badge primary--text"
        >
            {{ length }}
        </div>
        <div style="padding-top: 1px">
            {{ title }}
        </div>
        <div
            v-if="length > 1"
            style="margin-top: -3px"
        >
            <v-icon size="30" color="white">
                {{ menu ? "mdi-menu-up" : "mdi-menu-down" }}
            </v-icon>
        </div>
        <v-spacer />
        <slot name="right" />
    </div>
</template>

<script>
export default {
    name: "CSiteContactTitel",

    props: {
        title: {
            required: true,
            type    : String
        },

        length: {
            required: true,
            type    : Number
        },

        menu: {
            required: true,
            type    : Boolean
        },
    },
}
</script>

<style scoped>

.contact-title {
    width: 100%;
    height: 25px;
    color: white;
    font-size: 14px;
}

.contact-badge {
    width: 18px;
    height: 18px;
    line-height: 18px;
    background-color: white;
    text-align: center;
    font-weight: 400;
    margin-top: 2px;
    padding-top: 0;
    margin-right: 5px;
    border-radius: 2px;
    float: left;
    font-size: 14px;
}

</style>